<template>
  <div class="login">
    <div class="bgMp4">
      <img src="/static/picture/zzx_login_bg.png" alt width="100%" height="100%" />
    </div>
    <div class="systemWindow">
      <div class="logo">
        <img :src="env.LOGIN_FORM_LOGO" alt />
      </div>
      <div class="title_module">
        <div class="title">极速电子保函，让安全为您赢标</div>
      </div>
      <div class="subTitle">
        <span class="redTitle">中智信宜宾</span>
        <span>：出函快人一步，安全稳如泰山</span>
      </div>
    </div>
    <div class="loginWindow">
      <div class="loginTile">
        <div class="wocomeName">Hello！</div>
        <div class="name">{{ env.LOGIN_FORM_TITLE }}</div>
      </div>
      <div class="loginForm">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="" prop="userName">
          <!-- <el-form-item label="User Name" prop="userName"> -->
            <el-input class="loginName" placeholder="请输入账号" type="text" v-model="ruleForm.userName" @keyup.native.enter="loginEvent()">
              <template slot="prefix">
                <span style="color:#333">账号 <span style="color: #D9D9D9;">|</span></span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="passWord">
          <!-- <el-form-item label="Password" prop="passWord"> -->
            <el-input class="loginPassWord" placeholder="请输入密码" :type="flag ? 'text' : 'password'" v-model="ruleForm.passWord" @keyup.native.enter="loginEvent()">
              <template slot="prefix">
                <span style="color:#333">密码 <span style="color:#D9D9D9;">|</span></span>
              </template>
              <template slot="suffix">
                <i :class="flag ? 'el-icon-loginzhengyan' : 'el-icon-loginbiyan'" @click="flag = !flag"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="VerificationCode" prop="smsCode" v-if="$ENV.ISSMSCODESHOW">
            <el-input class="smsCode" type="text" v-model="ruleForm.smsCode">
              <template slot="prefix">
                <i class="el-icon-message"></i>
              </template>
              <template slot="suffix">
                <el-button type="text" @click="sendSmsCode" :disabled="smsButtonDisabled">
                  {{ smsButtonText }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button class="loginSubmit" type="primary" @click="loginEvent" :loading="loginLoad">登 录</el-button>
        <div class="version">{{ env.COPYRIGHT }} 版本：{{ env.VERSION }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  name: 'login',
  mixins: [mixin],
};
</script>
<style scoped lang="less">
@keyframes windowAnimation {
  from {
    top: 60%;
    opacity: 0;
  }
  to {
    top: 50%;
    opacity: 1;
  }
}
.login {
  position: relative;
  .bgMp4 {
    height: 100vh;
    display: flex;
    justify-content: center;
    // background: #222536;
    overflow: hidden;
  }
  .systemWindow {
    position: absolute;
    top: 10%;
    left: 162px;
    .logo {
      margin-bottom: 20px;
      width: 73px;
      height: 73px;
      img {
        height: 100%;
      }
    }
    .title_module {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 13px;
    }
    .subTitle{
      font-weight: bold;
      font-size: 20px;
      color:#333333;
      .redTitle{
        color: #EA1323;
      }
    }
  }
  .loginWindow {
    width: 384px;
    // height: 512px;
    background: #ffffff;
    box-shadow: 0px 3px 12px rgba(37, 38, 44, 0.08);
    border-radius: 20px;
    position: absolute;
    top: 50%;
    right: 198px;
    transform: translateY(-55%);
    padding: 0 40px;
    animation: windowAnimation 1s;
    .loginTile {
      padding-top: 64px;
      // display: flex;
      // flex-direction: column;
      // justify-content: center;
      // align-items: center;
      position: relative;
      .wocomeName {
        position: absolute;
        top: 30px;
        // font-size: 24px;
        font-weight: 600;
        font-size: 44px;
        color:#f6f6f6;
      }
      .name {
        position: relative;
        font-size: 20px;
        font-weight: bold;
        color: #333333;   
        // margin-top: 8px;
      }
    }
    .loginForm {
      margin-top: 43px;
      .el-form-item {
        margin-bottom: 24px;
      }

      .loginName,
      .loginPassWord {
        /deep/ .el-input__inner {
          background: #f7f9fc;
          // border-radius: 8px;
          padding: 0 48px;
        }
      }
      .loginSubmit {
        width: 100%;
        background: #e62129;
        border-color: #e62129;
        margin-top: 36px;
      }
      .version {
        font-size: 14px;
        font-weight: 400;
        color: #cccccc;
        margin-top: 64px;
        padding-bottom: 32px;
        text-align: center;
      }
      .el-icon-loginyonghu,
      .el-icon-mima {
        font-size: 20px;
        margin-left: 8px;
        margin-top: 10px;
      }
      .el-icon-loginzhengyan,
      .el-icon-loginbiyan {
        font-size: 20px;
        color: #e62129;
        margin-top: 10px;
        margin-right: 8px;
      }
      .el-button--text {
        color: #e62129;
      }
    }
  }
}
</style>
